import React from 'react';
import { useTranslation } from 'react-i18next';
import './ReportVorderseite.css';

// VorderseiteForm wird als Prop übergeben, da es in App.jsx definiert ist

/**
 * Komponente für Vorderseite im Report
 */
function ReportVorderseite({
  vorderseiteData,
  VorderseiteForm,
  getAnalysis,
  updateZusammenstellungVorgabezeiten,
  decimalPlacesSollzeiten,
  formatTime,
  ablaufDbName,
  setDeleteRowConfirm,
  pageNumber = 1,
  totalPages = 1,
  pageBreakAfter = 'always',
  userEmail,
  userDeviceName
}) {
  const { t } = useTranslation();
  if (!vorderseiteData || !VorderseiteForm) return null;

  return (
    <div className="report-section report-vorderseite" style={{ 
      pageBreakAfter, 
      position: 'relative', 
      minHeight: pageBreakAfter === 'always' ? '297mm' : 'auto'
    }}>
      <div className="report-page-number" style={{ 
        position: 'absolute', 
        bottom: '10mm', 
        left: '50%', 
        transform: 'translateX(-50%)', 
        fontSize: '10pt', 
        color: '#666', 
        width: '100%', 
        textAlign: 'center' 
      }}>
        {t('report.page_of', { page: pageNumber, total: totalPages })}
      </div>
      <VorderseiteForm
        data={vorderseiteData}
        onUpdate={() => {}}
        onSave={() => {}}
        isSaving={false}
        darkMode={false}
        getAnalysis={getAnalysis}
        updateZusammenstellungVorgabezeiten={updateZusammenstellungVorgabezeiten}
        onDataUpdate={() => {}}
        decimalPlacesVorderseite={vorderseiteData.decimal_places_vorderseite || decimalPlacesSollzeiten}
        formatVorderseiteTime={formatTime}
        setDeleteRowConfirm={setDeleteRowConfirm}
        fontScale={1}
        ablaufDbName={ablaufDbName}
        hideButtons={true}
      />
      {/* Footer mit Email und Device-Name */}
      <div className="report-vorderseite-footer" style={{ 
        marginTop: '8px', 
        paddingTop: '4px', 
        borderTop: '1px solid #ccc', 
        fontSize: '9px', 
        color: '#666', 
        textAlign: 'center' 
      }}>
        <div>{t('report.vorderseite.user')} {userEmail || t('report.not_specified')}</div>
        <div>{t('report.vorderseite.device')} {userDeviceName || t('report.unknown')}</div>
      </div>
    </div>
  );
}

export default ReportVorderseite;
